import React, { useContext, useState } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import Card from "../../components/Card/Card";
import Logo from "../../assets/Logo";
import axios from "axios";
import { base_url } from "../../config";
import "./style.css";
import WhiteBoxLayout from "../../components/WhiteBoxLayout/WhiteBoxLayout";

function RegistrationOption(props) {
  const { handler } = props;
  return (
    <div className="reg_container">
      <div className="flex-container">
        <div style={{ maxWidth: "300px", width: "100%" }}>
          <div className="w-full basis1 cursor-pointer inline-flex">
            <div onClick={handler}>
              <Card
                Logo={props.Logo}
                title={props.title}
                subtitle={props.subtitle}
              />
            </div>
          </div>
        </div>
        <div className="basis2 flex flex-col justify-between">
          <div className="content">{props.children}</div>
          <div> </div>
          <div className="lora"></div>
        </div>
      </div>
    </div>
  );
}

function RegistrationType() {
  const {
    setError,
    reload,
    setReload,
    phase,
    inCommunication,
    setInCommunication,
    prices,
  } = useContext(RegistrationContext);
  const Logo1 = () => <Logo width={100} height={100} color={"#002E78"} />;
  const Logo2 = () => <Logo width={100} height={100} color={"#98e1ff"} />;
  const { standardPrice, studentPrice } = {
    standardPrice: prices.standard,
    studentPrice: prices.student,
  };

  const handleSelect = async (selected_type) => {
    if (inCommunication) return;
    setInCommunication(true);
    // Reset login error state
    setError("");

    try {
      // Make a POST request to your authentication endpoint
      const response = await axios.post(`${base_url}/api/progress`, {
        type: selected_type,
      });
      setReload(reload + 1);
    } catch (error) {
      setError("Login failed. " + error.response.data.message);
    }
    setInCommunication(false);
  };

  return (
    <WhiteBoxLayout title="Select your registration Type" gray={true}>
      <div style={{ maxHeight: "100%" }}>
        <div className="lora">
          <RegistrationOption
            Logo={Logo1}
            title="Delegate Registration "
            subtitle={standardPrice + "€"}
            handler={() => handleSelect("standard")}
          >
            <div className="lora">
              <b>What's included:</b>
              <ul className="list-disc list-inside">
                <li>
                  All sessions of all tracks (research and ADS, journal, demo),
                  tutorials, workshops, discovery challenges and poster
                  presentations.
                </li>
                <li>Lunch and Coffee breaks.</li>
                <li>Ticket to the Conference Gala.</li>
                <li>Conference material.</li>
              </ul>
            </div>
          </RegistrationOption>
        </div>
        <div>
          <RegistrationOption
            Logo={Logo2}
            title="Student Registration"
            subtitle={studentPrice + "€"}
            handler={() => handleSelect("student")}
          >
            <div className="lora">
              <b>What's included:</b>
              <ul className="list-disc list-inside">
                <li>
                  All sessions of all tracks (research and ADS, journal, demo),
                  tutorials, workshops, discovery challenges and poster
                  presentations.
                </li>
                <li>Lunch and Coffee breaks.</li>
                <li>Ticket to the Conference Gala.</li>
                <li>Conference material.</li>
              </ul>
              <div className="mt-4">
                <b>Note:</b> You will be required to upload a proof of your
                student status during the registration process.
              </div>
            </div>
          </RegistrationOption>
        </div>
        <div
          className="lora"
          style={{
            marginTop: "3rem",
            padding: "1.25rem 1.5rem",
            border: "1px solid #002E78",
            borderRadius: "8px",
            backgroundColor: "#f0f4fa",
          }}
        >
          <p
            style={{
              marginBottom: "0.75rem",
              fontSize: "1.1rem",
              color: "#002E78",
            }}
          >
            <b>Important Information About Paper Registration</b>
          </p>
          <p>
            <b>Student Registration does not include</b> the right to register
            conference papers. To submit or present a paper, you must select{" "}
            <b>Delegate Registration</b>.
          </p>
          <p style={{ marginTop: "0.75rem" }}>
            Delegate Registration includes the registration of <b>one paper</b>.
            Additional papers can be registered for an extra fee (
            <b>€720 early rate / €820 late rate</b>).
          </p>
          <p style={{ marginTop: "0.75rem" }}>
            Paper registrations must be completed before <b>July 31st</b>.
          </p>

          <p style={{ marginTop: "0.75rem" }}>
            You may complete your registration now and add your paper details at
            a later stage (but before the Paper registration deadline at{" "}
            <b>July 31st</b>).
          </p>
        </div>
      </div>
    </WhiteBoxLayout>
  );
}

export default RegistrationType;
